export default "__VITE_ASSET__ab90a3c3__"